import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Footer from '../../base/components/Footer'

export default class MuseumContainer extends Component {

  static propTypes = {
    children: PropTypes.node
  }

  render() {
    return (
      <div className="container-fluid vertical content">
        {this.props.children}
        <Footer />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/museum/containers/Container.js